import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FilteringService } from 'src/app/services/filtering.service';
import { YardiClientMapping, YardiClientMeta } from '../../models/yardi';
import { IntegrationsService } from '../../services/integrations.service';
import { tap } from 'rxjs/internal/operators/tap';
import { IntegrationProvider } from '../../models/integrationModels';
import { YardiPropertyMappingModalComponent } from '../yardi-property-mapping-modal/yardi-property-mapping-modal.component';

@Component({
  selector: 'app-yardi-integration-pane',
  templateUrl: './yardi-integration-pane.component.html',
  styleUrls: ['./yardi-integration-pane.component.less']
})
export class YardiIntegrationPaneComponent implements OnInit, OnDestroy {

  @Input() riqClientId: number;
  connectionFailure: boolean = false;
  connectedDate: Date = new Date();
  transferTimestamp: Date = new Date();

  yardiMapping: YardiClientMapping;
  isYardiMapped: boolean = false;
  isYardiConnected: boolean = false;
  clientMeta: YardiClientMeta;

  connectionFailureMessage: string;
  $yardiClientMappingSub: Subscription;
  $clientMetaSub: Subscription;
  $clientSaveMappingSub: Subscription;

  constructor(public modalService: NgbModal, public integrations: IntegrationsService, public toast: ToastrService, public filtering: FilteringService) { }
  ngOnDestroy(): void {
    if(this.$yardiClientMappingSub) this.$yardiClientMappingSub.unsubscribe();
    if(this.$clientMetaSub) this.$clientMetaSub.unsubscribe();
    if(this.$clientSaveMappingSub) this.$clientSaveMappingSub.unsubscribe();
    this.yardiMapping = null;
  }

  ngOnInit() {
    // this.clientMapping = new RMO_ClientMapping();
    this.yardiMapping = new YardiClientMapping();
    this.$yardiClientMappingSub = this.integrations.GetYardiClientMapping(this.riqClientId).pipe(
      tap((_: YardiClientMapping) => {
        if(_) {
          this.yardiMapping = _;
          this.isYardiConnected = true;
          this.$clientMetaSub = this.integrations.GetYardiClientMeta(this.riqClientId).pipe(
            tap((res: YardiClientMeta) => {
            this.clientMeta = res;
          },
          err => {  },
          () => {})).subscribe()

        }
      })
    ).subscribe();
  }

  connectPmsClient(): void {
    console.log(this.yardiMapping);
    this.saveYardiMapping();
  }

  public get yardiConnectButtonText() : string {
    if(this.connectionFailure) return "Reconnect";
    if(this.isYardiConnected) return "Update Integration";
    else return "Connect";
  }

  mapProperties(): void {
    const modality = this.modalService.open(YardiPropertyMappingModalComponent, { centered: true, size: 'xl' });
    modality.componentInstance.name = "mapProps";
    modality.componentInstance.riqClientId = this.riqClientId;
    modality.componentInstance.pmsIdentifier = this.yardiMapping.userName;
    modality.componentInstance.pmsProvider = IntegrationProvider.Yardi;
  }

  saveYardiMapping(): void {
    if(!this.validate()) return;
    if(this.isYardiConnected) {
      //then fire off the update call
      this.$clientSaveMappingSub = this.integrations.UpdateYardiClientMapping(this.yardiMapping).pipe(
        tap((_: boolean) => {
          if(_) this.toast.success('Yardi mapping updated!');
          else this.toast.error('Error updating Yardi client mapping.', '', { closeButton: true, disableTimeOut: true });
        },
        err => {
          this.toast.error('Error updating Yardi client mapping.', '', { closeButton: true, disableTimeOut: true });
        })
      ).subscribe();
      return;
    }

    this.yardiMapping.riqClientId = this.riqClientId;
    this.$clientSaveMappingSub = this.integrations.SaveYardiClientMapping(this.yardiMapping).subscribe(res => {
      if(res) {
        this.isYardiConnected = true;
        this.toast.success(`RIQ Client mapped to Yardi Client ${this.yardiMapping.userName}`);
      } 
    },
    err => {
      if(err.status == 409) {
        this.toast.error(`A mapping already exists with Id: ${this.yardiMapping.userName}`);
      }
      else this.toast.error(`Error mapping client!`, '', { closeButton: true, disableTimeOut: true })
    })
  }

  validate(): boolean {
    this.connectionFailureMessage = "";
    this.connectionFailure = false;
    if(!this.yardiMapping.databaseName) this.connectionFailureMessage += "Please enter the client's supplied database name. \n\r"; 
    if(!this.yardiMapping.voyagerUrl) this.connectionFailureMessage += "Please provide the client's Voyager URL. \n\r"; 
    if(!this.yardiMapping.password) this.connectionFailureMessage += "Please provide the client's supplied Yardi password. \n"; 
    if(!this.yardiMapping.serverName) this.connectionFailureMessage += "Please provide the client's supplied server name. \n"; 
    if(!this.yardiMapping.userName) this.connectionFailureMessage += "Please provide the client's supplied username. \n"; 
    if(!this.yardiMapping.voyagerVersion) this.connectionFailureMessage += "Please provide the client's supplied Voyager version. \n"; 


    if(this.connectionFailureMessage)  {
      this.connectionFailure = true;
      return false;
    }
    else return true;
  }
}
